// Copyright (c) 2026 Theiagen Genomics. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use is prohibited.
// Default props for the tree viewer pipeline.

import { EmptyArray, TreeTypes } from "./constants.js";

export const defaultProps = Object.freeze({
  alignLabels: false,
  annotations: EmptyArray,
  annotationDefaults: {
    fillColor: [200, 200, 200, 255],
    strokeColor: [100, 100, 100, 255],
    strokeWidth: 2,
    opacity: 0.3,
    textColor: [0, 0, 0, 255],
    fontSize: 16,
    textPosition: "center",
    textRotation: 0,
  },
  annotationMode: false,
  onAnnotationCreate: null,
  onAnnotationUpdate: null,
  onAnnotationDelete: null,
  onLeafLabelAnnotationCreate: null,
  onLeafLabelAnnotationUpdate: null,
  onLeafLabelAnnotationDelete: null,
  backgroundColour: null,
  leafLabelAnnotations: EmptyArray,
  leafLabelAnnotationDefaults: {
    fillColor: [255, 200, 100, 255],
    strokeColor: [100, 100, 100, 255],
    strokeWidth: 1,
    opacity: 0.5,
  },
  leafLabelAnnotationMode: false,
  leafLabelAnnotationTrackSpacing: 20,
  blockHeaderFontSize: 13,
  blockPadding: 4,
  blocks: [],
  blockSize: 16,
  branchLabelsFontSize: null,
  branchLengthsDigits: 4,
  branchLengthsFormat: null,
  branchZoom: 0,
  centre: [0.5, 0.5],
  collapsedIds: EmptyArray,
  edgeOverlapFactor: -0.5,
  fillColour: [51, 51, 51, 255],
  fontColour: [51, 51, 51, 255],
  fontFamily: "monospace",
  fontSize: 16,
  haloRadius: 12,
  haloWidth: 4,
  highlightColour: [60, 115, 131, 255],
  interactive: false,
  highlightedId: null,
  scalebar: true,
  scalebarBackground: [255, 255, 255],
  scalebarDigits: 2,
  scalebarFillColour: [34, 34, 34],
  scalebarFontSize: 13,
  scalebarHeight: 24,
  scalebarLineWidth: 1,
  scalebarOpacity: 0.87,
  scalebarPadding: 4,
  scalebarPosition: { bottom: 0, left: 0 },
  scalebarStrokeColour: [34, 34, 34],
  scalebarWidth: 96,
  internalLabelsFilterRange: null,
  internalLabelsFontSize: null,
  labelLineDashArray: [4, 4],
  labelLineDashJustified: false,
  metadata: {},
  minScale: 0.01,
  nodeOverlapFactor: 0.1,
  nodeShape: "circle",
  nodeSize: 14,
  padding: 16,
  rootId: null,
  rotatedIds: EmptyArray,
  scaleLineAlpha: false,
  selectedIds: EmptyArray,
  shapeBorderAlpha: 0.28,
  shapeBorderWidth: 1,
  showBlockHeaders: false,
  showBlockLabels: false,
  showBranchLengths: false,
  showEdges: true,
  showInternalLabels: false,
  showLabels: false,
  showLeafLabels: false,
  showPiecharts: false,
  showShapeBorders: false,
  showShapes: true,
  size: { height: 150, width: 300 },
  stepZoom: 0,
  strokeColour: [34, 34, 34, 255],
  strokeWidth: 1,
  styleLeafLabels: false,
  styleNodeEdges: false,
  styles: {},
  treeToCanvasRatio: 0.25,
  type: TreeTypes.Rectangular,
  zoom: 0,
});
